import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Spinner} from "@chakra-ui/react";
import {ChevronDown, ChevronUp} from "lucide-react";
import useFeedback from "../../utils/use_feedback";
import {useCommunitySubscribe, useSuggestedCommunities} from "../../api/communities";
import {useStoreCommunity, useStoreProfile} from "../../store";
import {themecolors} from "../../utils/themecolors";
import {Button, Header, Title} from './sheet';

const TopicContainer = styled.div``;
const Topics = styled.div``;
const CommunityList = styled.div``;
const Selected = styled.div``;
const NotSelected = styled.div``;
const SpinnerContainer = styled.div``;

const CommunitySuggestionsSheet = styled(({className, selectedTopic, onClose}) => {

    const [topic, setTopic] = useState(selectedTopic);

    const {error, feedbackCh} = useFeedback();
    const suggestedCommunities = useSuggestedCommunities(feedbackCh);

    const subscribe = useCommunitySubscribe(feedbackCh);
    const [selected, setSelected] = useState([]);
    const handleSelect = async (name) => {
        const changed = selected.includes(name)
            ? selected.filter(element => element !== name)
            : [...selected, name];
        setSelected(changed);
    }
    const handleSubscribe = async () => {
        try {
            await subscribe(selected);
            onClose();
        } catch {
            console.log("Failed to subscribe.");
        }
    }
    const {theme} = useStoreProfile();

    return (
        <div className={className}>

            <Header>
                <Title>Join Communities</Title>
                {selected.length > 0 &&
                    <Button onClick={handleSubscribe}>
                        Save
                    </Button>
                }
            </Header>

            <Topics className={className}>
                {suggestedCommunities && Object.keys(suggestedCommunities).length > 0 ?
                    <TopicTabs topic={topic} setTopic={setTopic} suggestedCommunities={suggestedCommunities}
                               handleSelect={handleSelect} selected={selected} handleSubscribe={handleSubscribe}/>
                    :
                    <SpinnerContainer>
                        <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor={theme === "dark" ? themecolors.dark_background_5 : themecolors.light_low_impact_text}
                            color={theme === "dark" ? themecolors.dark_background_2 : themecolors.pure_white}
                            size='lg'
                        />
                    </SpinnerContainer>
                }
            </Topics>

        </div>
    );
})`
  ${SpinnerContainer} {
    text-align: center;
    padding: 48px 0;
  }
`;

const Topic = styled(({className, name, selected, onClick}) => {
    const Div = selected ? Selected : NotSelected;
    const community = useStoreCommunity(name);
    return !community.is_subscribed ? (
        <Div className={className} onClick={onClick}>
            {name}
        </Div>
    ) : <></>
})`
  &${Selected} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : 'rgb(238 238 238)'};
  }

  cursor: pointer;
  font-size: 15px;
  padding: 4px 14px;
  border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : 'rgb(238 238 238)'};
  border-radius: 16px;
  margin: 0 4px 6px 0;
  white-space: nowrap;
`;

const TopicItem = styled(({className, topics, topic, activeTopic, setActiveTopic, handleSelect, selected}) => {
    const {subscribed} = useStoreProfile();
    const lowercaseSubscribed = subscribed.map(item => item.toLowerCase());
    const unsubscribed = topics.filter(c => !lowercaseSubscribed.includes(c.toLowerCase()));
    return (
        <div className={className}>
            <TopicContainer onClick={() => setActiveTopic(activeTopic === topic ? "" : topic)}>
                {topic}
                {activeTopic === topic ?
                    <ChevronUp size={18} />
                    :
                    <ChevronDown size={18} />
                }
            </TopicContainer>
            {activeTopic === topic &&
            <CommunityList>
                {unsubscribed.map((t) => (
                    <Topic key={t} name={t} onClick={() => handleSelect(t)} selected={selected.includes(t)}/>
                ))}
            </CommunityList>
            }
        </div>
    )
})`
  padding-bottom: 16px;

  ${TopicContainer} {
    font-size: 16px;
    display: flex;
    cursor: pointer;
  }

  ${CommunityList} {
    display: flex;
    font-size: 15px;
    margin-top: 12px;
    flex-wrap: wrap;
  }

  svg {
    margin-left: auto;
  }
`;

export const TopicTabs = ({topic, setTopic, suggestedCommunities, handleSelect, selected, handleSubscribe}) => {
    return (
        <>
            {Object.keys(suggestedCommunities).map((key) => (
                <TopicItem key={key} topics={suggestedCommunities[key]} topic={key} activeTopic={topic}
                           setActiveTopic={setTopic}
                           handleSelect={handleSelect} selected={selected}/>
            ))}
        </>
    );
}


export default CommunitySuggestionsSheet;
